import React, { useState } from "react";
import { Popover } from "@mui/material";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MonthCalendar } from "@mui/x-date-pickers/MonthCalendar";
import moment from "moment";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function MonthPickerPopover(props) {
  const { anchorEl, handleClose, month, setMonth } = props;

  const [value, setvalue] = useState(month);

  return (
    <Popover
      open={!!anchorEl}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
    >
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <MonthCalendar
          value={value}
          onChange={(newDate) => {
            setvalue(newDate);
          }}
          views={["month"]}
        />
      </LocalizationProvider>
      <div className="py-4 px-6 flex items-center justify-end">
        <button
          type="button"
          onClick={() => {
            setMonth(value);
            handleClose();
          }}
          className="button-size rounded bg-blue-btn-primary"
        >
          OK
        </button>
      </div>
    </Popover>
  );
}

function SelectMonth(props) {
  const { month, setMonth } = props;

  const [showSelectMonthEl, setShowSelectMonthEl] = useState(null);
  return (
    <>
      <div className="w-28 h-8 pr-8 relative">
        <button
          onClick={(e) => setShowSelectMonthEl(e.currentTarget)}
          className="w-full h-full rounded-md pl-4 pr-8 flex items-center relative border border-gray-400"
        >
          <p>
            {month ? (
              month.format("MM")
            ) : (
              <span className="text-gray-500">MM</span>
            )}
          </p>

          <div
            className={`absolute right-1 top-1 w-6 h-6 flex items-center justify-center transition-all ${
              showSelectMonthEl ? "rotate-180" : ""
            }`}
          >
            <FontAwesomeIcon icon={faChevronDown} />
          </div>
        </button>

        <div className="absolute w-8 h-8 right-0 inset-y-0 flex items-center justify-center">
          月
        </div>
      </div>

      {showSelectMonthEl ? (
        <MonthPickerPopover
          anchorEl={showSelectMonthEl}
          handleClose={() => setShowSelectMonthEl(null)}
          month={month}
          setMonth={setMonth}
        />
      ) : null}
    </>
  );
}

export default SelectMonth;
